import { styled } from "styled-components";

export const StyledNewVersionInfoModalContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
`;

export const StyledNewVersionInfoModalFooter = styled.div`
  margin-top: 20px;
`;
